import React from 'react';

// Components
import Btn from '../Btn';
import { BtnType } from '../Btn/Btn';

type MicroInteractionButtonType = BtnType & {
  currentInteraction: string;
  interactions: any;
};

export function MicroInteractionButton(props: MicroInteractionButtonType) {
  return <Btn {...{ ...props, ...props.interactions[props.currentInteraction] }} />;
}
